import {Empty as EmptyComponent} from 'antd';

const Empty = ({description}) => {
    return <div className='col-12 text-center mt-5 mb-5'><EmptyComponent description={description}/></div>
}
export default Empty
